import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

// TODO Inject them via props.
// import {onBlur} from '../../onBlur';
// import {onFocus} from '../../onFocus';

export default class TextAreaInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    rows: PropTypes.string,
    label: React.PropTypes.string,
    maxCharacters: PropTypes.number,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }

  lengthWithLineBreaks = (string) => {
    return string.replace(/\r\n/g, '~~').replace(/\n/g, '~~').length;
  }

  preAction = (e) => {
    const {action, maxCharacters} = this.props;
    const {value} = e.target;
    if (maxCharacters <= this.lengthWithLineBreaks(value)) {
      e.target.value = value.substring(0, maxCharacters);
    }
    action(e);
  }

  render() {
    const {
      name,
      title,
      label,
      value,
      rows
    } = this.props;
    return (
      <div className="form-group">
        {label &&
          <label>{label}</label>
        }
        <textarea
          className="form-control"
          rows={rows}
          name={name}
          placeholder={title}
          value={value}
          onChange={this.preAction}
          onBlur={::this.onInputBlur}
          onFocus={::this.onInputFocus}
          ref="input"
        />
      </div>
    );
  }
}
